// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__jj9Uu","buttons":"PendingPaymentAlert_buttons__3HEK3"};